export default "__VITE_ASSET__CbeECtYt__"